<script>
export default {
  props: ["clr"]
};
</script>
<template>
  <svg
    id="documet-edit-pen"
    xmlns="http://www.w3.org/2000/svg"
    width="22"
    height="22"
    viewBox="0 0 22 22"
  >
    <g id="Group_1394" data-name="Group 1394" transform="translate(2.75 2.75)">
      <path
        id="Path_8656"
        data-name="Path 8656"
        d="M16.75,13.083v4.583h0A1.833,1.833,0,0,1,14.917,19.5H4.833A1.833,1.833,0,0,1,3,17.667H3V4.833H3A1.833,1.833,0,0,1,4.833,3H14.917A1.833,1.833,0,0,1,16.75,4.833v2.75"
        transform="translate(-3 -3)"
        fill="none"
        :stroke="clr ? clr : '#500fe9'"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
      />
      <path
        id="Path_8657"
        data-name="Path 8657"
        d="M13,12.963v2.371h2.371a.917.917,0,0,0,.648-.269l3.746-3.745h0a1.945,1.945,0,0,0,0-2.75h0a1.945,1.945,0,0,0-2.75,0l-3.746,3.745h0a.917.917,0,0,0-.269.648Z"
        transform="translate(-3.833 -3.417)"
        fill="none"
        :stroke="clr ? clr : '#500fe9'"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
      />
      <path
        id="Path_8658"
        data-name="Path 8658"
        d="M7,12H9.75"
        transform="translate(-3.333 -3.75)"
        fill="none"
        :stroke="clr ? clr : '#500fe9'"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
      />
      <path
        id="Path_8659"
        data-name="Path 8659"
        d="M7,16H9.75"
        transform="translate(-3.333 -4.083)"
        fill="none"
        :stroke="clr ? clr : '#500fe9'"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
      />
      <path
        id="Path_8660"
        data-name="Path 8660"
        d="M7,8h6.417"
        transform="translate(-3.333 -3.417)"
        fill="none"
        :stroke="clr ? clr : '#500fe9'"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
      />
    </g>
    <path id="Path_8661" data-name="Path 8661" d="M0,0H22V22H0Z" fill="none" />
  </svg>
</template>
